import {
  GET_PROJECT_EXPENSES, CREATE_PROJECT_EXPENSE,
  UPDATE_PROJECT_EXPENSE, DELETE_PROJECT_EXPENSE
} from '../actions/projectExpenseActions';

const initialState = { expenses: [], numberOfPages: 1, isLoading: false };

const projectExpense = (state = initialState, action) => {
  switch (action.type) {
    case GET_PROJECT_EXPENSES:
      return { ...state, expenses: action.payload.expenses, numberOfPages: action.payload.totalPages };
    case CREATE_PROJECT_EXPENSE:
      return { ...state, expenses: [action.payload, ...state.expenses] };
    case UPDATE_PROJECT_EXPENSE:
      return { ...state, expenses: state.expenses.map(e => e._id === action.payload._id ? action.payload : e) };
    case DELETE_PROJECT_EXPENSE:
      return { ...state, expenses: state.expenses.filter(e => e._id !== action.payload) };
    default:
      return state;
  }
};

export default projectExpense;
